import { DelegatedStepsEnum, SelectOption } from '@/types/types.ts';

import i18n from '@/plugins/i18n';

export function delegatedStepsOptions(): SelectOption<string>[] {
  return [
    DelegatedStepsEnum.container_drayage,
    DelegatedStepsEnum.export_customs_clearance,
    DelegatedStepsEnum.import_customs_clearance,
    DelegatedStepsEnum.truck_delivery
  ].map((val: string) => {
    return { value: val, label: i18n.t(`delegatedSteps.${val}`).toString() };
  });
}
